import { FC, type ReactNode } from "react";

import { DrawerContentFadeInStyled } from "./drawer-content-fade-in.styled";
import { DrawerEntityDataLoader } from "./drawer-entity-data-loader";

interface IDrawerFormContentGateProps {
  isLoading: boolean;
  entityTitle: string;
  children: ReactNode;
}

export const DrawerFormContentGate: FC<IDrawerFormContentGateProps> = ({
  isLoading,
  entityTitle,
  children,
}) => {
  if (isLoading) {
    return <DrawerEntityDataLoader entityTitle={entityTitle} />;
  }

  return <DrawerContentFadeInStyled>{children}</DrawerContentFadeInStyled>;
};
